import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";

function TemplateA() {
  return (
    <>
      <Navbar />
      <main>
        <section className="h-[250px] m-auto pt-[90px] page-title">
          <div className="text-center mb-[44px]">
            <h2 className="text-[#3D3D3D] font-normal text-5xl mb-[15px]">阿爾發AI理財顧問</h2>
            <h3 className="text-[#696969] font-normal text-xl" style={{ color: "#ff6b2b" }}>
              Introduction
            </h3>
          </div>
        </section>
        <section className="h-[700px] w-[980px] m-auto mt-[64px] mb-[152px]">
          <img src="./alphaAI.png" alt="" className="m-auto mb-[85px]" />
          <div className="text-start text-[#373737] font-normal text-base leading-loose ">
            <p>
              核心業務：阿爾發AI理財顧問是一家領先的技術驅動公司，專注於提供先進的AI解決方案，以幫助客戶管理和增長其資產。通過結合最新的
            </p>
            <p>
              數據分析技術和深度學習算法，該公司為其客戶提供了獨特而高效的投資策略，並能夠在不同的市場環境中實現穩定的回報。
            </p>
            <p>
              技術優勢：阿爾發的核心競爭力在於其強大的AI技術。該公司的研究團隊長期與世界頂尖的學術機構合作，不斷優化其算法，以應對金融市
            </p>
            <p>
              場的不斷變化。此外，透過即時的大數據分析，阿爾發能夠即時獲得市場動態，幫助客戶捕捉投資機會。核心業務：阿爾發AI理財顧問是一
            </p>
            <p>
              家領先的技術驅動公司，專注於提供先進的AI解決方案，以幫助客戶管理和增長其資產。通過結合最新的數據分析技術和深度學習算法，該
            </p>
            <p>公司為其客戶提供了獨特而高效的投資策略，並能夠在不同的市場環境中實現穩定的回報。</p>
            <p>
              技術優勢：阿爾發的核心競爭力在於其強大的AI技術。該公司的研究團隊長期與世界頂尖的學術機構合作，不斷優化其算法，以應對金融市
            </p>
            <p>
              場的不斷變化。此外，透過即時的大數據分析，阿爾發能夠即時獲得市場動態，幫助客戶捕捉投資機會。
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default TemplateA;
